// Theme configuration
export const theme = {
  fonts: {
    primary:
      "'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    weights: {
      hairline: 100,
      light: 300,
      regular: 400,
      bold: 700,
      black: 900,
    },
  },
};

// Export font family helper
export const fontFamily = {
  primary: theme.fonts.primary,
};

// Export font weight constants
export const fontWeight = theme.fonts.weights;
